<template>
  <span>
    <div v-if="label">{{ label }}</div>
    <span>{{ toMoney(value || 0) }}</span>
  </span>
</template>

<script>
import { toMoney } from "@/utils/numeric";

export default {
  name: "AmountLabel",
  props: {
    value: {
      validator: prop => typeof prop === "number" || typeof prop === "string" || prop === null || prop === undefined,
      required: true
    },
    label: {
      type: String
    }
  },
  setup() {
    return { toMoney };
  }
};
</script>